var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorRedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4148 22.028C25.2291 22.2138 25.0086 22.3613 24.7658 22.4619C24.5231 22.5625 24.2629 22.6142 24.0002 22.6142C23.7374 22.6142 23.4772 22.5625 23.2345 22.4619C22.9918 22.3613 22.7712 22.2138 22.5855 22.028L16.4708 15.9146C16.3458 15.7897 16.1763 15.7195 15.9995 15.7195C15.8227 15.7195 15.6532 15.7897 15.5282 15.9146L9.41484 22.028C9.03982 22.4032 8.53112 22.614 8.00064 22.6142C7.47016 22.6143 6.96136 22.4037 6.58617 22.0287C6.21098 21.6536 6.00013 21.1449 6 20.6145C5.99988 20.084 6.21049 19.5752 6.5855 19.2L12.7002 13.0853C13.1335 12.6519 13.648 12.3081 14.2142 12.0736C14.7804 11.839 15.3873 11.7183 16.0002 11.7183C16.613 11.7183 17.2199 11.839 17.7861 12.0736C18.3524 12.3081 18.8668 12.6519 19.3002 13.0853L25.4148 19.2C25.7898 19.575 26.0004 20.0837 26.0004 20.614C26.0004 21.1443 25.7898 21.6529 25.4148 22.028Z",
    fill: "#ED3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorRedIcon);
export default __webpack_public_path__ + "static/media/vectorRed_icon.7e2bcd16bd18809691c932081cf91566.svg";
export { ForwardRef as ReactComponent };